import { Modal, Card } from "@mui/material";
import Button from "@mui/material/Button";
import { useEffect, useRef, useState } from "react";
import AllDataClass from "pages/common/AllDataClass";
import "./PolicyDetail.scss";
import ConflictPolicy from "./ConflictPolicy";
import { useTranslation } from "react-i18next";

type ModalProp = {
  policyModalOpen: boolean;
  handleClose: () => void;
  policy: any;
  category: any;
  selectedPolicyLists: any[];
  setSelectedPolicyLists: React.Dispatch<React.SetStateAction<any[]>>;
};

const PolicyDetail = ({
  policyModalOpen,
  handleClose,
  policy,
  category,
  selectedPolicyLists,
  setSelectedPolicyLists,
}: ModalProp): JSX.Element => {
  if (!policy) {
    return;
  }
  const { t } = useTranslation();
  const [isSelected, setIsSelected] = useState(false);
  const [detail, setDetail] = useState("explain");
  const [policyId, setPolicyID] = useState("");
  const [prev_policy, setPrevPolicy] = useState("");
  const policy_id = Object.keys(policy)[0];
  const policy_values = policy[policy_id];
  const Policies: any = AllDataClass.getPolicies();
  const Policy = Policies[policy_id];
  const leftButtonClickHandler = (state: any) => {
    setDetail(state);
  };

  // if (GV?.selectedPolicies.includes(policy_id)) {
  //   setIsSelected(true);
  // }
  useEffect(() => {
    setPolicyID(policy_id);
    if (AllDataClass?.selectedList?.includes(Object.keys(policy)[0])) {
      setIsSelected(true);
    } else {
      setIsSelected(false);
    }
  }, [selectedPolicyLists]);

  const removePolicy = () => {
    var tmparray = [...AllDataClass.selectedList];
    console.log(tmparray);
    var idx = tmparray.indexOf(policy_id);
    if (idx >= 0) {
      // tmparray = tmparray.filter(function (item) {
      //   return item !== policy_id;
      // });
      // GV.setSelectedPolicies(tmparray);
      AllDataClass.removeSelectedList(policy_id);
    }
    setSelectedPolicyLists([...AllDataClass.selectedList]);
    console.log(AllDataClass.selectedList);
    setIsSelected(false);
    handleClose();
  };

  const [conflictmodal, setConflictModal] = useState(false);
  const addPolicy = () => {
    var confilctList = AllDataClass.getConflictPolicies(policy_id);
    var isConflicted = false;
    AllDataClass.selectedList?.forEach((id: string) => {
      if (confilctList.indexOf(id) >= 0) {
        setPrevPolicy(id);
        setConflictModal(true);
        isConflicted = true;
        return;
      }
    });
    if (isConflicted) {
      handleClose();
      return;
    }
    if (!AllDataClass.selectedList?.includes(policy_id)) {
      AllDataClass.addSelectedList(policy_id);
    }
    setSelectedPolicyLists([...AllDataClass.selectedList]);
    setIsSelected(false);
    handleClose();
  };
  const closeModal = () => {
    setIsSelected(false);
    setSelectedPolicyLists([...AllDataClass.selectedList]);
    handleClose();
  };
  const conflictModalClose = () => {
    setConflictModal(false);
  };
  return (
    <div>
      <ConflictPolicy
        open={conflictmodal}
        prev_policy={prev_policy}
        cur_policy={policy_id}
        conflictModalClose={conflictModalClose}
        setSelectedPolicyLists={setSelectedPolicyLists}
      />
      <Modal
        open={policyModalOpen}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="policy-detail-modal"
      >
        <div className="modal-top">
          <div className="modal-details">
            <div className="modal-title">{policy_values && policy_values[2]}</div>
            <div className="modal-category-wrap">
              <div className="modal-category">{category}</div>
            </div>
            {/* <div className="modal-spending-wrap">
              <div className="modal-spending">
                {(Policy && Policy[1]) || "SEPNDING SAMPLE $$$$$"}
              </div>
            </div> */}
            <div className="modal-detail-wrap">
              <div className="modal-detail">
                <div className="modal-detail-title">
                  {detail === "explain" && t("explain")}
                  {detail === "arg_for" && t("arg_for")}
                  {detail === "arg_against" && t("arg_against")}
                </div>
                <div className="modal-detail-content">
                  {detail === "explain" &&
                    policy_values &&
                    policy_values[3]
                      .split("\n")
                      .map((item: any, idx: number) => <span key={idx}>{item}</span>)}
                  {detail === "arg_for" &&
                    policy_values &&
                    policy_values &&
                    policy_values[4]
                      .split("\n")
                      .map((item: any, idx: number) => <span key={idx}>{item}</span>)}
                  {detail === "arg_against" &&
                    policy_values &&
                    policy_values &&
                    policy_values[5]
                      .split("\n")
                      .map((item: any, idx: number) => <span key={idx}>{item}</span>)}
                </div>
              </div>
            </div>
          </div>
          <div className="modal-left-button">
            <button
              onClick={() => {
                setDetail("explain");
              }}
            >
              <div>{t("explain")}</div>
            </button>
            <button
              onClick={() => {
                setDetail("arg_for");
              }}
            >
              <div>{t("arg_for")}</div>
            </button>
            <button
              onClick={() => {
                setDetail("arg_against");
              }}
            >
              <div>
                {t("arg_against")
                  .split("\n")
                  .map((item: any, idx: number) => (
                    <span key={idx}>
                      {item}
                      {idx > 0 ? <br /> : ""}
                    </span>
                  ))}
              </div>
            </button>
          </div>
          <div className="modal-bottom-button">
            <button
              onClick={() => {
                setDetail("explain");
                handleClose();
              }}
            >
              <span>{t("back")}</span>
            </button>
            {!AllDataClass?.selectedList?.includes(Object.keys(policy)[0]) ? (
              <button
                onClick={() => {
                  setDetail("explain");
                  addPolicy();
                }}
              >
                <span>{t("choose")}</span>
              </button>
            ) : (
              <button
                onClick={() => {
                  setDetail("explain");
                  removePolicy();
                }}
              >
                <span>{t("remove")}</span>
              </button>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default PolicyDetail;
